import {
  Component,
  EventEmitter,
  Inject,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  AppStore,
  SnackbarErrorAction,
  UnlockWriteAction,
  ViewNodeVersionAction,
} from '@alfresco/aca-shared/store';
import { Node, Version } from '@alfresco/js-api';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { NodeEntityEvent } from '@alfresco/adf-content-services';

// #region Interfaces (1)

export interface NodeVersionDialogData {
  // #region Properties (5)

  currentVersion?: Version;
  file?: File;
  node: Node;
  showVersionsOnly?: boolean;
  title: string;

  // #endregion Properties (5)
}

// #endregion Interfaces (1)

// #region Classes (1)

@Component({
  templateUrl: './wk-node-versions.dialog.html',
  styleUrls: ['./wk-node-versions.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'aca-node-versions-dialog' },
  standalone: false,
})
export class NodeVersionsDialogComponent {
  // #region Properties (1)

  /** Emitted when a version is restored or deleted. */
  @Output()
  public refreshEvent = new EventEmitter<Node>();

  // #endregion Properties (1)

  // #region Constructors (1)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: NodeVersionDialogData,
    private readonly store: Store<AppStore>,
    private readonly dialogRef: MatDialogRef<NodeVersionsDialogComponent>,
    private readonly router: Router
  ) {}

  // #endregion Constructors (1)

  // #region Public Methods (5)

  public handleCancel(): void {
    this.dialogRef.close();
  }

  public handleUpload(nodeEvent: NodeEntityEvent): void {
    if (nodeEvent.value.entry.properties['cm:lockType'] === 'WRITE_LOCK') {
      this.store.dispatch(new UnlockWriteAction(nodeEvent.value));
    }
    this.handleCancel();
  }

  public onUploadError(errorMessage: any): void {
    this.store.dispatch(new SnackbarErrorAction(errorMessage));
  }

  public onViewingVersion(versionId: string): void {
    this.store.dispatch(
      new ViewNodeVersionAction(this.data.node.id, versionId, {
        location: this.router.url,
      })
    );
  }

  public refresh(node: Node): void {
    this.refreshEvent.emit(node);
  }

  // #endregion Public Methods (5)
}

// #endregion Classes (1)
